<template>
  <ContentWrap>
    <el-tabs v-model="activeTab">
      <!-- 基本 -->
      <el-tab-pane label="基本" name="basic">
        <el-form label-width="140px" class="mt-12px">
          <el-form-item label="开启全民股东">
            <el-switch v-model="form.open" />
          </el-form-item>
          <el-form-item label="内购分红">
            <el-switch v-model="form.selfBuy" />
            <el-text class="w-full" size="small" type="info">开启后，股东自购完成单也计入分红池</el-text>
          </el-form-item>
          <el-form-item label="结算周期">
            <el-radio-group v-model="form.settleCycle">
              <el-radio :value="0">手动</el-radio>
            </el-radio-group>
            <el-text class="w-full" size="small" type="info">P0 仅支持手动创建结算单；周/月为二期</el-text>
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 资格 -->
      <el-tab-pane label="资格" name="become">
        <el-form label-width="140px" class="mt-12px">
          <el-form-item label="成为条件">
            <el-select v-model="form.becomeType" class="!w-md">
              <el-option
                v-for="o in SHAREHOLDER_BECOME_TYPE"
                :key="o.value"
                :label="o.label"
                :value="o.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item v-if="form.becomeType === 1 || form.becomeType === 2 || form.becomeType === 3 || form.becomeType === 4" label="需要审核">
            <el-switch v-model="form.becomeCheck" />
          </el-form-item>
          <el-form-item v-if="form.becomeType === 2 || form.becomeType === 3 || form.becomeType === 4" label="消费统计口径">
            <el-radio-group v-model="form.becomeOrder">
              <el-radio v-for="o in SHAREHOLDER_BECOME_ORDER" :key="o.value" :value="o.value">
                {{ o.label }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.becomeType === 2" label="消费次数">
            <el-input-number v-model="form.becomeOrderCount" :min="1" class="!w-xs" />
          </el-form-item>
          <el-form-item v-if="form.becomeType === 3" label="消费金额(元)">
            <el-input-number v-model="becomeMoneyYuan" :min="0" :precision="2" class="!w-xs" />
          </el-form-item>
          <el-form-item v-if="form.becomeType === 4" label="指定商品">
            <div>
              <SpuShowcase v-model="becomeGoodsSpuIds" />
              <el-text class="w-full" size="small" type="info">
                购买以下任一商品（按所选统计口径）后可自动成为股东
              </el-text>
            </div>
          </el-form-item>
          <el-form-item v-if="form.becomeType === 0" label="非股东提示">
            <el-input v-model="form.noregDesc" type="textarea" :rows="2" class="!w-md" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 结算 -->
      <el-tab-pane label="结算" name="settle">
        <el-form label-width="140px" class="mt-12px">
          <el-form-item label="池比例(%)">
            <el-input-number v-model="form.bonusRate" :min="0" :max="100" :precision="4" class="!w-xs" />
            <el-text class="w-full" size="small" type="info">空或未填按 100%</el-text>
          </el-form-item>
          <el-form-item label="入池天数">
            <el-input-number v-model="form.settleDays" :min="0" class="!w-xs" />
            <el-text class="w-full" size="small" type="info">完成后满 N 天才入池（receiveTime）</el-text>
          </el-form-item>
          <el-form-item label="提现手续费(%)">
            <el-input-number v-model="form.payCharge" :min="0" :max="100" :precision="2" class="!w-xs" />
          </el-form-item>
          <el-form-item label="免手续费起(元)">
            <el-input-number v-model="payBeginYuan" :min="0" :precision="2" class="!w-xs" />
          </el-form-item>
          <el-form-item label="免手续费止(元)">
            <el-input-number v-model="payEndYuan" :min="0" :precision="2" class="!w-xs" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 升级 -->
      <el-tab-pane label="升级" name="level">
        <el-form label-width="140px" class="mt-12px">
          <el-form-item label="升级依据">
            <el-select v-model="form.levelType" class="!w-lg">
              <el-option
                v-for="o in SHAREHOLDER_LEVEL_TYPE"
                :key="o.value"
                :label="`${o.value} · ${o.label}`"
                :value="o.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="等级说明链接">
            <el-input v-model="form.levelUrl" class="!w-md" placeholder="可选，C 端展示" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 中心 -->
      <el-tab-pane label="中心" name="center">
        <el-form label-width="160px" class="mt-12px">
          <el-form-item label="会员中心入口">
            <el-switch v-model="form.openMemberCenter" />
          </el-form-item>
          <el-form-item label="关闭分销中心入口">
            <el-switch v-model="form.closeCommissionCenter" />
            <el-text class="w-full" size="small" type="info">关闭=不在分销中心展示；开启开关表示隐藏入口</el-text>
          </el-form-item>
          <el-form-item label="股东须知">
            <el-input v-model="form.centerDesc" type="textarea" :rows="4" class="!w-md" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 文案：右侧为 C 端展示文案；左侧为中文说明（底层 JSON key 仍为英文） -->
      <el-tab-pane label="文案" name="texts">
        <el-alert
          class="mb-12px mt-12px"
          type="info"
          :closable="false"
          title="这里配置会员端页面上的用词。改右侧中文即可；保存后写入 textsJson。"
        />
        <el-form label-width="140px">
          <el-form-item
            v-for="(val, key) in textsMap"
            :key="key"
            :label="TEXT_FIELD_LABELS[key] || String(key)"
          >
            <el-input v-model="textsMap[key]" class="!w-md" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 协议 -->
      <el-tab-pane label="协议" name="protocol">
        <el-form label-width="140px" class="mt-12px">
          <el-form-item label="显示申请协议">
            <el-switch v-model="form.openProtocol" />
          </el-form-item>
          <el-form-item label="协议内容">
            <el-input v-model="form.protocolContent" type="textarea" :rows="8" class="!w-lg" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 通知 -->
      <el-tab-pane label="通知" name="notice">
        <el-alert
          class="mb-16px mt-12px"
          type="info"
          :closable="false"
          title="站内信默认开启；微信订阅需公众平台同名模板。通知失败不影响主流程。本 Tab 独立保存。"
        />
        <el-form v-loading="noticeLoading" label-width="140px">
          <el-divider content-position="left">成为股东</el-divider>
          <el-form-item label="站内信">
            <el-switch v-model="notice.become!.notifyEnabled" />
          </el-form-item>
          <el-form-item label="微信订阅">
            <el-switch v-model="notice.become!.wxaEnabled" />
          </el-form-item>
          <el-form-item v-if="notice.become?.wxaEnabled" label="模板标题">
            <el-input v-model="notice.become!.wxaTemplateTitle" class="!w-md" />
          </el-form-item>
          <el-form-item v-if="notice.become?.wxaEnabled" label="跳转页面">
            <el-input v-model="notice.become!.page" class="!w-md" />
          </el-form-item>

          <el-divider content-position="left">等级升级</el-divider>
          <el-form-item label="站内信">
            <el-switch v-model="notice.upgrade!.notifyEnabled" />
          </el-form-item>
          <el-form-item label="微信订阅">
            <el-switch v-model="notice.upgrade!.wxaEnabled" />
          </el-form-item>
          <el-form-item v-if="notice.upgrade?.wxaEnabled" label="模板标题">
            <el-input v-model="notice.upgrade!.wxaTemplateTitle" class="!w-md" />
          </el-form-item>
          <el-form-item v-if="notice.upgrade?.wxaEnabled" label="跳转页面">
            <el-input v-model="notice.upgrade!.page" class="!w-md" />
          </el-form-item>

          <el-divider content-position="left">分红到账</el-divider>
          <el-form-item label="站内信">
            <el-switch v-model="notice.settle!.notifyEnabled" />
          </el-form-item>
          <el-form-item label="微信订阅">
            <el-switch v-model="notice.settle!.wxaEnabled" />
          </el-form-item>
          <el-form-item v-if="notice.settle?.wxaEnabled" label="模板标题">
            <el-input v-model="notice.settle!.wxaTemplateTitle" class="!w-md" />
          </el-form-item>
          <el-form-item v-if="notice.settle?.wxaEnabled" label="跳转页面">
            <el-input v-model="notice.settle!.page" class="!w-md" />
          </el-form-item>

          <el-form-item>
            <el-button
              v-hasPermi="['distribution:shareholder:config:save']"
              type="primary"
              :loading="noticeLoading"
              @click="submitNotice"
            >
              保存通知配置
            </el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>

    <el-form-item v-if="activeTab !== 'notice'" class="mt-16px">
      <el-button
        v-hasPermi="['distribution:shareholder:config:save']"
        type="primary"
        :loading="loading"
        @click="submitConfig"
      >
        保存
      </el-button>
    </el-form-item>
  </ContentWrap>
</template>

<script lang="ts" setup>
import { cloneDeep } from 'lodash-es'
import * as ConfigApi from '@/api/mall/trade/shareholder/config'
import { yuanToFen, fenToYuanNumber } from '@/utils'
import SpuShowcase from '@/views/mall/product/spu/components/SpuShowcase.vue'
import {
  DEFAULT_TEXTS,
  TEXT_FIELD_LABELS,
  SHAREHOLDER_BECOME_ORDER,
  SHAREHOLDER_BECOME_TYPE,
  SHAREHOLDER_LEVEL_TYPE
} from '../constants'

defineOptions({ name: 'TradeShareholderConfig' })

const message = useMessage()
const activeTab = ref('basic')
const loading = ref(false)
const noticeLoading = ref(false)

const form = reactive<ConfigApi.ShareholderConfigVO>({
  open: false,
  selfBuy: false,
  becomeType: 0,
  becomeCheck: true,
  becomeOrder: 0,
  becomeOrderCount: undefined,
  becomeMoney: undefined,
  becomeGoodsIds: '',
  noregDesc: '想成为股东吗？请立即联系我们！',
  bonusRate: 100,
  settleDays: 0,
  payCharge: undefined,
  payBegin: undefined,
  payEnd: undefined,
  levelType: 0,
  levelUrl: '',
  openMemberCenter: false,
  closeCommissionCenter: false,
  settleCycle: 0,
  openProtocol: false,
  protocolContent: '',
  textsJson: '',
  centerDesc: '',
  noticeJson: ''
})

/** 与后端 becomeGoodsIds（JSON 数组字符串）双向同步，UI 用 SpuShowcase 选商品 */
const becomeGoodsSpuIds = computed<number[]>({
  get() {
    if (!form.becomeGoodsIds) return []
    try {
      const list = JSON.parse(form.becomeGoodsIds)
      if (!Array.isArray(list)) return []
      return list.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0)
    } catch {
      return []
    }
  },
  set(ids: number[]) {
    const cleaned = (ids || []).map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0)
    form.becomeGoodsIds = cleaned.length ? JSON.stringify(cleaned) : ''
  }
})

const becomeMoneyYuan = ref(0)
const payBeginYuan = ref(0)
const payEndYuan = ref(0)
const textsMap = reactive<Record<string, string>>({ ...DEFAULT_TEXTS })

const emptyNoticeItem = (title: string, page: string): ConfigApi.ShareholderNoticeItemVO => ({
  notifyEnabled: true,
  wxaEnabled: false,
  wxaTemplateTitle: title,
  page
})

const notice = reactive<ConfigApi.ShareholderNoticeConfigVO>({
  become: emptyNoticeItem('股东成为通知', 'pages/modules/mall/shareholder/index'),
  upgrade: emptyNoticeItem('股东升级通知', 'pages/modules/mall/shareholder/index'),
  settle: emptyNoticeItem('分红到账通知', 'pages/modules/mall/shareholder/bonus')
})

const parseTexts = (json?: string) => {
  Object.assign(textsMap, DEFAULT_TEXTS)
  if (!json) return
  try {
    const obj = JSON.parse(json)
    Object.keys(DEFAULT_TEXTS).forEach((k) => {
      if (obj[k] != null) textsMap[k] = String(obj[k])
    })
  } catch {
    /* ignore */
  }
}

const loadConfig = async () => {
  loading.value = true
  try {
    const data = await ConfigApi.getShareholderConfig()
    Object.assign(form, data || {})
    form.settleCycle = 0
    becomeMoneyYuan.value = fenToYuanNumber(data?.becomeMoney ?? 0)
    payBeginYuan.value = fenToYuanNumber(data?.payBegin ?? 0)
    payEndYuan.value = fenToYuanNumber(data?.payEnd ?? 0)
    parseTexts(data?.textsJson)
  } finally {
    loading.value = false
  }
}

const loadNotice = async () => {
  noticeLoading.value = true
  try {
    const data = await ConfigApi.getShareholderNotice()
    notice.become = {
      ...emptyNoticeItem('股东成为通知', 'pages/modules/mall/shareholder/index'),
      ...data?.become
    }
    notice.upgrade = {
      ...emptyNoticeItem('股东升级通知', 'pages/modules/mall/shareholder/index'),
      ...data?.upgrade
    }
    notice.settle = {
      ...emptyNoticeItem('分红到账通知', 'pages/modules/mall/shareholder/bonus'),
      ...data?.settle
    }
  } finally {
    noticeLoading.value = false
  }
}

const submitConfig = async () => {
  if (form.becomeType === 4 && becomeGoodsSpuIds.value.length === 0) {
    message.warning('请选择至少一件指定商品')
    activeTab.value = 'become'
    return
  }
  loading.value = true
  try {
    const data = cloneDeep(form) as ConfigApi.ShareholderConfigVO
    data.settleCycle = 0
    data.becomeMoney = yuanToFen(becomeMoneyYuan.value || 0)
    data.payBegin = yuanToFen(payBeginYuan.value || 0)
    data.payEnd = yuanToFen(payEndYuan.value || 0)
    data.textsJson = JSON.stringify(textsMap)
    // 非「购买指定商品」时清空，避免残留旧配置误触发
    if (data.becomeType !== 4) {
      data.becomeGoodsIds = ''
    }
    await ConfigApi.saveShareholderConfig(data)
    message.success('保存成功')
    await loadConfig()
  } finally {
    loading.value = false
  }
}

const submitNotice = async () => {
  noticeLoading.value = true
  try {
    await ConfigApi.saveShareholderNotice(notice)
    message.success('通知配置已保存')
    await loadNotice()
  } finally {
    noticeLoading.value = false
  }
}

onMounted(async () => {
  await Promise.all([loadConfig(), loadNotice()])
})
</script>
